import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {useParams} from 'react-router'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../_metronic/layout/core'
import {DropdownDefault, InputDefault, TableDefault} from '../../../components/ui'
import ModalImportVoucher from '../../../components/sections/ModalImportVoucher'
import {members} from '../../../mocks'
import {
  deleteRewardDetailById,
  getDetailRewards,
  getRewardsById,
} from '../../../modules/services/rewards.service'
import {getBreadCrumbs} from '../breadcrumbs'

const RewardsCatalogDetail = () => {
  const queryClient = useQueryClient()
  const {id} = useParams()
  const headFields = ['ID', 'Voucher Code', 'Status', 'Member', 'Expiried Date']
  const bodyFields = [
    'id',
    'attributes.code',
    'attributes.status',
    'attributes.member.data.attributes.fullname',
    'attributes.expired_date',
  ]
  const [filter, setFilter] = useState('')
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(
    ['getDetailRewards', id, filter, search, page],
    async () => await getDetailRewards(id, search, filter, page)
  )
  const {data: dataDetail, isLoading: loading} = useQuery(['getRewardsBy'], async () =>
    getRewardsById(id)
  )
  const nameReward: string = dataDetail?.data?.attributes?.name
  const descriptionReward: string = dataDetail?.data?.attributes?.description
  const QtyReward: number = data?.meta?.pagination?.total
  const countAvail: number = dataDetail?.meta?.available
  const pageCount: number = data?.meta?.pagination.pageCount

  const handleDelete = (id: any) => {
    mutate(id)
  }

  const {mutate, isLoading: loadings} = useMutation(deleteRewardDetailById, {
    onSuccess: async () => {
      toast.success('Delete Data Succes')
      await queryClient.invalidateQueries('getDetailRewards')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-end align-items-center py-8'>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#import-modal-voucher'
              >
                Import
              </button>
              <Link to={`/rewardscreate/${id}`}>
                <button
                  className='btn btn-primary'
                >
                  Add
                </button>
              </Link>
            </div>

            <div className='d-flex flex-row gap-4'>
              <InputDefault
                placeholder='Search Voucher Code'
                onChange={(e: any) => setSearch(e.target.value)}
                left={<i className='bi bi-search' />}
              />
              <DropdownDefault
                type='Filter'
                list={members.filtersStatus}
                dataState={[filter, setFilter]}
              />
            </div>
          </div>
        </div>
        {!loading && (
          <div className='ms-6'>
            <p className='fw-bold fs-1 p-0 m-0'>{`Voucher - ${nameReward}`}</p>
            <p className='fw-bold fs-7 p-0 m-1'>{`Description : ${descriptionReward}`}</p>
            <p className='fw-bold fs-7 p-0 m-1'>{`Qty : ${QtyReward}`}</p>
            <p className='fw-bold fs-7 p-0 m-1'>{`Available Voucher : ${countAvail} Voucher`}</p>
          </div>
        )}
        {!isLoading && (
          <TableDefault
            head={headFields}
            body={bodyFields}
            data={data.data}
            handleDelete={handleDelete}
            showEdit={false}
            allPaginate={pageCount}
            page={page}
            setsPage={setPage}
            nextPage={nextPage}
            prevPage={prevPage}
            href={'rewards'}
            loadings={loadings}
          />
        )}
        <ModalImportVoucher id={id as string} />
      </div>
    </>
  )
}

const RewardsCatalogWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('loyalty-point/rewards-detail')}>
        {intl.formatMessage({id: 'MENU.REWARDS_CATALOG'})}
      </PageTitle>
      <RewardsCatalogDetail />
    </>
  )
}

export default RewardsCatalogWrapper
